export enum LightboxMediaType {
    Document = 'document',
    Image = 'image',
    Unsupported = 'unsupported',
    Video = 'video',
}

export interface LightboxElement {
    key: string;
    title: string;
    type: LightboxMediaType;
    url: string;
}

export interface LightboxState {
    elements: LightboxElement[];
    index: number;
    isLoopbackEnabled: boolean;
}

export const initialState: LightboxState = {
    elements: [],
    index: 0,
    isLoopbackEnabled: false,
};

export default initialState;
